import { useRouter } from "next/router";
import { FilterType } from "../../../../../types/transformedFilterEntity";
import { useQueryClient } from "@tanstack/react-query";

export type queryFiltersType = { [key in FilterType]: string[] };

export const useProductListingFilter = () => {
  const router = useRouter();
  const sortBy = router.query.sortBy ? (router.query.sortBy as string) : "";
  const page = router.query.page ? Number(router.query.page) : 1;

  const getPriceRange = () => {
    const priceRange = router.query.sellingPrice as string;
    if (priceRange) {
      const slicedData = priceRange
        .slice(1, priceRange.length - 1)
        .split(" TO ");
      return {
        min: parseInt(slicedData[0]),
        max: parseInt(slicedData[1]),
      };
    }
    return {
      min: 0,
      max: 30000,
    };
  };
  const priceRange = getPriceRange();

  const getQueryParams = (property: string) => {
    const query = router.query[property] as string;
    if (query) {
      return query.split(",");
    }
    return [];
  };
  const queryFilters = {
    category: getQueryParams("category"),
    brand: getQueryParams("brand"),
    color: getQueryParams("color"),
    material: getQueryParams("material"),
    pattern: getQueryParams("pattern"),
    trend: getQueryParams("trend"),
    availableSize: getQueryParams("availableSize"),
    availability: getQueryParams("availability"),
  };

  const changeRoute = (query: any) => {
    router.push({
      pathname: router.asPath.includes("collections")
        ? "/collections/[id]"
        : "/search/[id]",
      query,
    });
  };

  const setQueryFilters = (queryParams: any) => {
    const updatedQuery = { ...router.query };
    const trasformedQuery = Object.entries(queryParams).reduce(
      (acc, [key, value]: any) => {
        if (value.length > 0) {
          acc[key] = value.join(",");
        } else {
          delete updatedQuery[key];
        }
        return acc;
      },
      {} as any
    );
    changeRoute({ ...updatedQuery, ...trasformedQuery });
  };

  const setSortBy = (sortBy: string) =>
    changeRoute({
      ...router.query,
      sortBy,
    });

  const setPriceRange = (priceRange: any) =>
    changeRoute({
      ...router.query,
      sellingPrice: `[${priceRange.min} TO ${priceRange.max}]`,
    });

  const setPage = (page: number) => changeRoute({ ...router.query, page });

  return {
    priceRange,
    setPriceRange,
    queryFilters,
    setQueryFilters,
    sortBy,
    setSortBy,
    page,
    setPage,
  };
};
